import { CursorArrowRippleIcon } from "@heroicons/react/24/outline";
import CuratedSearchCardHeader from "../CuratedSearchCard/CuratedSearchCardHeader";
import classNames from "classnames";
import SuggestedPrompts from "../CuratedSearchPrompt/CuratedSearchPromptEdit/SuggestedPrompts";
import CuratedSearchPromptEditDescription from "../CuratedSearchPrompt/CuratedSearchPromptEdit/CuratedSearchPromptEditDescription";
import { useState } from "react";
import CiroButton, { CiroButtonStyleEnum } from "../../shared/CiroButton";
import CiroModal from "../../shared/CiroModal";
import { gql } from "@apollo/client";

export const CuratedSearchDesignImproveResultsModal_searchAnalysisPreview = gql`
  fragment CuratedSearchDesignImproveResultsModal_searchAnalysisPreview on SearchAnalysisPreviewResults {
    analysisResults {
      org_contact {
        id
      }
      scoringCriteriaResults {
        criterion_fit
        reasoning
        criterion_id
        sources
      }
    }
  }
`;

const CuratedSearchDesignImproveResultsModal = ({
  suggestedPrompts,
  handleSubmitRemix,
  isOpen,
  onClose,
}: {
  suggestedPrompts: string[];
  handleSubmitRemix: (prompt: string) => void;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const [selectedPrompt, setSelectedPrompt] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const handlePromptChange = (prompt: string) => {
    setSelectedPrompt(prompt);

    if (prompt) {
      setError("");
    }
  };

  return (
    <CiroModal isOpen={isOpen} onClose={onClose} size="LARGE">
      <div
        className={classNames(
          "flex",
          "justify-between",
          "items-center",
          "pb-4",
        )}
      >
        <CuratedSearchCardHeader
          headerText={"Improve results"}
          headerIcon={
            <CursorArrowRippleIcon
              className={classNames("w-6", "h-6", "text-orange-500")}
            />
          }
        />
      </div>
      <CuratedSearchPromptEditDescription
        error={error}
        setError={setError}
        prompt={selectedPrompt}
        setPrompt={handlePromptChange}
        placeholder={"How would you like to improve your search?"}
      />
      {suggestedPrompts && suggestedPrompts.length > 0 && (
        <SuggestedPrompts
          text={"Or pick one of the feedback suggestions:"}
          prompts={suggestedPrompts}
          onSelectPrompt={handlePromptChange}
        />
      )}
      <div className={classNames("flex", "gap-2", "justify-end")}>
        <CiroButton
          style={CiroButtonStyleEnum.PRIMARY}
          analyticsField="Remix autopilot search"
          onClick={() => onClose()}
        >
          <span>Cancel</span>
        </CiroButton>
        <CiroButton
          style={CiroButtonStyleEnum.LOUD}
          analyticsField="Remix autopilot search"
          onClick={() => handleSubmitRemix(selectedPrompt)}
        >
          Submit
        </CiroButton>
      </div>
    </CiroModal>
  );
};

export default CuratedSearchDesignImproveResultsModal;
